import { useState, useEffect, useCallback } from 'react';

/**
 * Custom hook to track network connectivity status
 * Provides online/offline state and sync status
 */
export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        // Trigger any sync operations here
        console.log('[Network] Back online - ready to sync');
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
      console.log('[Network] Went offline');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  // Reset wasOffline flag
  const clearOfflineFlag = useCallback(() => {
    setWasOffline(false);
  }, []);

  return { isOnline, wasOffline, clearOfflineFlag };
}

export default useNetworkStatus;
